import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { AcessoService, MenuItem } from '@src/app/services/acesso.service';

@Component({
    selector: 'app-horizontal-sidebar',
    imports: [CommonModule, TablerIconsModule, MaterialModule, AppHorizontalNavItemComponent],
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems: MenuItem[] = [];
  parentActive = '';

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public navService: NavService,
    public router: Router,
    media: MediaMatcher,
    private readonly cdr: ChangeDetectorRef,
    private acessoService: AcessoService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => this.cdr.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(() => {
      this.parentActive = this.router.url.split('/')[1];
      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    // Carrega menu dinâmico do backend
    this.navItems = this.acessoService.construirMenu();

    // Atualiza menu quando acessos mudarem
    this.acessoService.acessos$.subscribe(() => {
      this.navItems = this.acessoService.construirMenu();
      this.cdr.markForCheck();
    });
  }
}
